import { t } from 'i18next';

export const errors = {
  BT01: (cutoff?: number) => t('errors.BT01', { cutoff }),
  ST01: (cutoff?: number) => t('errors.ST01', { cutoff }),
  R01: (cutoff?: number) => t('errors.R01', { cutoff }),
  R02: (cutoff?: number) => t('errors.R02', { cutoff }),
  TS01: () => t('errors.TS01'),
  EC01: (cutoff?: number) => t('errors.EC01', { cutoff }),
  EC02: (cutoff?: number) => t('errors.EC02', { cutoff }),
  EC03: (cutoff?: number) => t('errors.EC03', { cutoff }),
  EC04: (cutoff?: number) => t('errors.EC04', { cutoff }),
  EC05: (cutoff?: number) => t('errors.EC05', { cutoff }),
  EC06: (cutoff?: number) => t('errors.EC06', { cutoff }),
  EC07: (cutoff?: number) => t('errors.EC07', { cutoff }),
  EC08: (cutoff?: number) => t('errors.EC08', { cutoff }),
  EC09: (cutoff?: number) => t('errors.EC09', { cutoff }),
  EC10: (cutoff?: number) => t('errors.EC10', { cutoff }),
  EC12: (cutoff?: number) => t('errors.EC12', { cutoff }),
  EC13: () => t('errors.EC13'),
  EC11: (cutoff?: number) => t('errors.EC11', { cutoff }),
};
